import { Esercizio } from "./Esercizio";
import { Sessione } from "./Sessione";

export const isValidEsercizio = (esercizio: Esercizio) => {
  const baseValid =
    esercizio.full_name?.trim() &&
    esercizio.full_description?.trim() &&
    esercizio.position &&
    esercizio.purpose &&
    esercizio.execution &&
    esercizio.mode &&
    esercizio.muscle_groups?.length > 0 &&
    esercizio.posture &&
    esercizio.gravity_management_complexity > 0 &&
    esercizio.motor_coordination_complexity > 0 &&
    esercizio.cardiorespiratory_complexity > 0 &&
    esercizio.animation &&
    esercizio.body_tracking &&
    esercizio.evaluation_params_cgg.length > 0 &&
    esercizio.evaluation_params_ccm.length > 0 &&
    esercizio.evaluation_params_icr.length > 0

  return (baseValid);
};



